import { Drawer, DrawerBody, DrawerContent, DrawerHeader, DrawerOverlay } from '@chakra-ui/react';

import {
  CustomerNotification,
  DismissCustomerNotificationMutationFn,
} from '../../../gql/generated/graphql';
import NotificationsHeader from './NofificationsHeader';
import NotificationItem from './NotificationItem';
import NotificationsZeroState from './NotificationsZeroState';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  notDismissedNotifications: CustomerNotification[];
  dismissedNotifications: CustomerNotification[];
  dismissNotification: DismissCustomerNotificationMutationFn;
  showDismissed: boolean;
  toggleShowDismissed: () => void;
  setOpenNotificationModal: (a: string | null) => void;
};

const MobileNotifications = ({
  isOpen,
  onClose,
  notDismissedNotifications,
  dismissedNotifications,
  dismissNotification,
  showDismissed,
  toggleShowDismissed,
  setOpenNotificationModal,
}: Props) => {
  const notifications = showDismissed ? dismissedNotifications : notDismissedNotifications;
  const hasNotifications = notifications.length > 0;

  return (
    <Drawer placement="bottom" onClose={onClose} isOpen={isOpen}>
      <DrawerOverlay />
      <DrawerContent roundedTop="lg" maxH="50vh" overflowY="scroll">
        <DrawerHeader>
          <NotificationsHeader
            m={4}
            showDismissed={showDismissed}
            toggleShowDismissed={toggleShowDismissed}
          />
        </DrawerHeader>
        <DrawerBody>
          {hasNotifications ? (
            notifications.map((notification) => (
              <NotificationItem
                showDismissed={showDismissed}
                key={`mobile-notification-${notification.id}`}
                notification={notification}
                dismissNotification={dismissNotification}
                setOpenNotificationModal={setOpenNotificationModal}
              />
            ))
          ) : (
            <NotificationsZeroState showDismissed={showDismissed} />
          )}
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  );
};

export default MobileNotifications;
